import { AdminModule, AdminModuleListEntryStatus } from 'types/admin/modules';
import { create } from 'zustand';

export type GeneralDataState = Omit<AdminModule, 'chapters' | 'certifications'>;
type State = GeneralDataState & { initializing: boolean; loading: boolean, isOrganizationOnly: boolean, allowedOrganizationIds: string[] };

type Actions = {
  setInitialData: (data: Omit<AdminModule, 'chapters' | 'certifications'>) => void;
  setId: (id: string) => void;
  setTitle: (title: string) => void;
  setShortDescription: (shortDescription: string) => void;
  setFullDescription: (fullDescription: string) => void;
  setImageId: (imageId: string) => void;
  setStatus: (status: AdminModuleListEntryStatus) => void;
  setIsOrganizationOnly: (isOrganizationOnly: boolean) => void;
  setAllowedOrganizationIds: (allowedOrganizationIds: any) => void;
  reset: () => void;
  setLoadingInitialData: (initializing: boolean) => void;
  setLoading: (loading: boolean) => void;
};

export const useGeneralStore = create<State & Actions>((set, get, store) => ({
  id: '',
  title: '',
  shortDescription: '',
  fullDescription: '',
  imageId: '',
  status: 'Hidden',
  initializing: false,
  loading: false,
  isOrganizationOnly: false,
  allowedOrganizationIds: [],
  setInitialData: (data: Omit<AdminModule, 'chapters' | 'certifications'>) =>
    set(() => ({
      id: data.id,
      title: data.title,
      shortDescription: data.shortDescription,
      fullDescription: data.fullDescription,
      status: data.status,
      imageId: data.imageId,
      isOrganizationOnly: data.isOrganizationOnly,
      allowedOrganizationIds: data.allowedOrganizationIds,
    })),
  setTitle: (title: string) => set(() => ({ title })),
  setId: (id: string) => set(() => ({ id })),
  setShortDescription: (shortDescription: string) => set(() => ({ shortDescription })),
  setFullDescription: (fullDescription: string) => set(() => ({ fullDescription })),
  setImageId: (imageId: string) => set(() => ({ imageId })),
  setStatus: (status: AdminModuleListEntryStatus) => set(() => ({ status })),
  setIsOrganizationOnly: (isOrganizationOnly: boolean) =>
    set(() => isOrganizationOnly ? { isOrganizationOnly } : { isOrganizationOnly, allowedOrganizationIds: [] }),
  setAllowedOrganizationIds: (allowedOrganizationIds: string[]) => set(() => ({ allowedOrganizationIds })),
  reset: () => set(store.getInitialState()),
  setLoadingInitialData: (initializing: boolean) => set(() => ({ initializing })),
  setLoading: (loading: boolean) => set(() => ({ loading })),
}));
